import React, { useEffect, useState } from 'react';
import Wrapper from '../components/Wrapper';
import {
  Button,
  Divider,
  Form,
  Input,
  InputNumber,
  Modal,
  Switch,
  Table,
  TableColumnsType,
  Tag,
} from 'antd';
import { getCategories, upsertCategories } from '../shared/api';
import { useLoadingSetter } from '~/providers/LoadingProvider';
import message from '~/utils/message';
import { Category as CategoryType } from '../shared/types/Category';

const Category = () => {
  const setLoading = useLoadingSetter();
  const [form] = Form.useForm();
  const [categories, setCategories] = useState<CategoryType[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    getAllCategories();
  }, []);

  const columns: TableColumnsType<CategoryType> = [
    {
      title: 'Category',
      dataIndex: 'name',
    },
    {
      title: 'Sequence',
      dataIndex: 'seq',
    },
    {
      title: 'Active',
      dataIndex: 'isActive',
      render: (_, { isActive }) => {
        if (isActive) {
          return <Tag color="green">ACTIVE</Tag>;
        }
        return <Tag color="red">INACTIVE</Tag>;
      },
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Button onClick={() => handleEdit(record)} type="link">
          Edit
        </Button>
      ),
    },
  ];

  const getAllCategories = async () => {
    setLoading(true);
    const { data, errorMsg } = await getCategories();
    if (errorMsg) {
      setCategories([]);
      message.error(errorMsg);
    } else {
      setCategories(data);
    }
    setLoading(false);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const handleCreate = () => {
    form.setFieldsValue({ isActive: true });
    setIsModalOpen(true);
  };

  const handleEdit = (category: CategoryType) => {
    form.setFieldsValue(category);
    setIsModalOpen(true);
  };

  const handleSave = async () => {
    setLoading(true);
    const { errorMsg } = await upsertCategories({
      categories: [form.getFieldsValue(true)],
    });
    setLoading(false);

    // Failure handling.
    if (errorMsg) {
      message.error(errorMsg);
      return;
    }
    message.success('Category saved');
    closeModal();
    getAllCategories();
  };

  return (
    <Wrapper>
      <Button type="primary" onClick={handleCreate}>
        New Category
      </Button>
      <Divider />
      <Table columns={columns} dataSource={categories} pagination={false} />
      <Modal
        open={isModalOpen}
        title={form.getFieldValue('id') ? 'Edit' : 'Create'}
        footer={[
          <Button onClick={handleSave} type="primary">
            Save
          </Button>,
          <Button onClick={closeModal}>Close</Button>,
        ]}
        onCancel={closeModal}
      >
        <br />
        <Form form={form} labelCol={{ span: 4 }} wrapperCol={{ span: 20 }}>
          <Form.Item name="name" label="Category">
            <Input />
          </Form.Item>
          <Form.Item name="seq" label="Sequence">
            <InputNumber step={10} />
          </Form.Item>
          <Form.Item name="isActive" label="Active" valuePropName="checked">
            <Switch />
          </Form.Item>
        </Form>
      </Modal>
    </Wrapper>
  );
};

export default Category;
